import React from 'react';
import { styled } from '@material-ui/core';

import { StatsItem } from '../StatsItem';

const StatsItemWrapper = styled(({ textAlign: _textAlign, variant: _variant, ...other }) => (
  <div {...other} />
))(({ textAlign, theme, variant }) => ({
  display: 'grid',
  gridTemplateColumns: `${
    variant === 'inline' ? `repeat(auto-fit, minmax(180px, 1fr))` : 'auto auto'
  }`,
  gap: theme.spacing(2),
  '& p, .valueLabel': {
    textAlign,
    whiteSpace: 'nowrap'
  }
}));

/**
 * @param {Object} props
 * @param {Object[]} props.items
 * @param {'left'|'right'|'center'} [props.textAlign='left']
 * @param {'inline'|'grid'} [props.variant='inline']
 */
export const StatsItemContainer = ({ items, textAlign = 'left', variant = 'inline' }) => {
  return (
    <StatsItemWrapper role="list" textAlign={textAlign} variant={variant}>
      {items.map(item => (
        <StatsItem key={item.title} {...item} />
      ))}
    </StatsItemWrapper>
  );
};
